import { InvoiceType } from '@/Enums';
import { ProductDynamicColumnValueModel, ProductModel } from '@/Models';
import { ProductTableRow, ProductTransferTableRow } from '@/Types';
import { OrderItemProductShortTableRow } from '@/Types/OrderItemProductShortTableRow';
import { v4 as uuidv4 } from 'uuid';
import { orderTableRowUtils } from '@/Types/OrderTableRowUtils';
import { orderMapping } from '@/Mapping/OrderMapping';
import { OrderItemModel } from '@/Models/Order/OrderItemModel';

// Converting one product to table row
function convertProductToProductTableRow(product: ProductModel): ProductTableRow {
  return {
    ...product,
    productPackagesCount: product.productPackages?.length || 0,
    productPackagesString: product.productPackages?.map((item) => `${item.name}${item.sku}${item.ean}`).join(','),
    productCategoryName: product.productCategory.name,
    customProductFields: product.customProductFields
      ? (product.customProductFields.map((item) => {
          if (item.value == 'true' || item.value == 'false') {
            return {
              ...item,
              value: item.value == 'true',
            };
          }

          return item;
        }) as ProductDynamicColumnValueModel[])
      : [],
  };
} // convertProductToProductTableRow

function convertProductToProductTransferTableRow(
  product: ProductModel,
  quantity: number,
  isLastModified: boolean,
): ProductTransferTableRow {
  return {
    ...product,
    isLastModified,
    quantity,
  };
} // convertProductToProductTransferTableRow

// Converting product array to table row array
function convertProductsToProductTableRows(products: ProductModel[]): ProductTableRow[] {
  return products.map(convertProductToProductTableRow);
} // convertProductsToProductTableRows

function convertOrderItemModelToProductShortTableRow(orderItem: OrderItemModel): OrderItemProductShortTableRow {
  return {
    id: orderItem.id,
    sku: orderItem.sku,
    name: orderItem.title,
    uid: uuidv4(),
    variant: orderMapping.getVariants(orderItem),
    category: '',
    priceNetto: orderItem.priceNetto,
    priceBrutto: orderItem.priceBrutto,
    quantity: orderItem.quantity,
    totalPriceBruttoWithoutShipping: orderTableRowUtils.calculateOrderItemPrice(InvoiceType.GrossInvoice, orderItem),
    totalPriceNettoWithoutShipping: orderTableRowUtils.calculateOrderItemPrice(InvoiceType.NetInvoice, orderItem),
    vat: orderItem.salesTaxPercent,
    shippingCostBrutto: orderItem.shippingCostBrutto,
    shippingCostNetto: orderItem.shippingCostNetto,
  };
}

export const productMapping = {
  convertProductToProductTableRow,
  convertProductToProductTransferTableRow,
  convertProductsToProductTableRows,
  convertOrderItemModelToProductShortTableRow,
};
